import { createFileRoute } from "@tanstack/react-router";
import { ChatColumn } from "@/components/copilot/ChatColumn";
import { CompanionPanel } from "@/components/companion/CompanionPanel";

export const Route = createFileRoute("/copilot")({
  component: CopilotPage,
});

function CopilotPage() {
  return (
    <div className="flex h-full min-w-0">
      <div className="flex min-w-0 basis-[60%] flex-grow">
        <ChatColumn />
      </div>
      <div className="border-border flex min-w-0 basis-[40%] flex-grow border-l">
        <CompanionPanel />
      </div>
    </div>
  );
}
